import React from "react";
import { OverlayView } from "@react-google-maps/api";
import { Spring } from "react-spring/renderprops";
import { usePrevious } from "../../../hooks";
import { ReactComponent as CarIcon } from "./icons/ic_map_car_2.svg";


const getPixelPositionOffset = (width, height) => ({
  x: -(width / 2),
  y: -(height / 2),
});

function toRadians(degrees) {
  return degrees * Math.PI / 180;
}

// Converts from radians to degrees.
function toDegrees(radians) {
  return radians * 180 / Math.PI;
}

function bearing(startLat, startLng, destLat, destLng) {
  startLat = toRadians(startLat);
  startLng = toRadians(startLng);
  destLat = toRadians(destLat);
  destLng = toRadians(destLng);


  let y = Math.sin(destLng - startLng) * Math.cos(destLat);
  let x = Math.cos(startLat) * Math.sin(destLat) -
    Math.sin(startLat) * Math.cos(destLat) * Math.cos(destLng - startLng);

  let brng = Math.atan2(y, x);
  brng = toDegrees(brng);
  return (brng + 360) % 360;
}

export default React.memo(({ lat, lng }) => {

  const prevPoint = usePrevious({
    lat,
    lng,
  });

  let bearing1 = prevPoint ? bearing(prevPoint?.lat, prevPoint?.lng, lat, lng) : Math.floor(Math.random() * 360);

  return (
    <Spring
      to={{
        lat: lat,
        lng: lng,
      }}
      config={{
        duration: 20000,
      }}
    >
      {animatedLocation =>
        <OverlayView
          position={{
            lat: animatedLocation.lat,
            lng: animatedLocation.lng,
          }}
          mapPaneName={OverlayView?.OVERLAY_MOUSE_TARGET}
          getPixelPositionOffset={getPixelPositionOffset}
        >
          <CarIcon style={{ transform: `rotate(${bearing1}deg)` }} />
        </OverlayView>
      }
    </Spring>
  );
});

